import React from 'react';
import { TypedInput } from '@hummingbirdtechgroup/wings-ui';
import { InputWrapper } from '..';
const NumberInput = (props) => (React.createElement(TypedInput, { type: "number", ...props }));
NumberInput.Controlled = (props) => (React.createElement(InputWrapper, { ...props },
    React.createElement(NumberInput, null)));
export default NumberInput;
//# sourceMappingURL=NumberInput.js.map